import { formatter } from './common_product_list_pro'
cb.define([], function() { //商品列表
  var PC_pc_productlist_querybycustomer_VM_Extend = {
    doAction: function(name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function(viewmodel) {
      formatter(viewmodel)
      let gridModel = viewmodel.getGridModel();
      gridModel.on('beforeDblClick', (args) => {
        args.source = 'Customer' 
        args.ids = {
          customerId: args.rowData.customerId,
          shopId: args.rowData.shopId,
          orgId: args.rowData.orgId
        }
      })
    }
  }
  try {
    module.exports = PC_pc_productlist_querybycustomer_VM_Extend;
  } catch (error) {
    // 当 类型 为 档案 的时候
  }
  return PC_pc_productlist_querybycustomer_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_productlist_querybycustomer_VM.Extend.js